module.exports = __webpack_public_path__ + "img/login-v2-dark.e731d05d.svg";